import { orchestrator } from 'satcheljs';
import { resetComposeStore } from 'owa-calendar-compose-form-actions';
import { removeComposeStore } from 'owa-calendar-compose-store-manager';
import resetLocationFeedbackManager from 'owa-feedback-manager-actions/lib/actions/resetLocationFeedbackManager';

const resetComposeStoreOrchestrator = orchestrator(resetComposeStore, actionMessage => {
    removeComposeStore(actionMessage.formId);
    resetLocationFeedbackManager();
});

// Exported for testing
export { resetComposeStoreOrchestrator };
